import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const ProjectsEditToggle = ({ company, subcompany, project, t }) => (
  <Form.Link
    className="btn btn-outline-primary btn-sm mx-2"
    to={createRoute(company.id, subcompany.id, `projects/${project.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(ProjectsEditToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/actions/ProjectsActionsEdit.js